export default __webpack_public_path__ + "static/media/omar.455918b5.jpg";